export interface CheckpointArgument {
  id: string
  challengeID: string
  sortOrder: number
  threshold: number
  title: string
  description: string
  imageUrl?: string
  videoUrl?: string
  lat?: number
  lng?: number
}

export default class Checkpoint {
  readonly id: string
  readonly challengeID: string
  readonly sortOrder: number
  readonly threshold: number
  readonly title: string
  readonly description: string
  readonly imageUrl?: string
  readonly videoUrl?: string
  readonly lat?: number
  readonly lng?: number

  constructor(arg: CheckpointArgument) {
    this.id = arg.id
    this.challengeID = arg.challengeID
    this.sortOrder = arg.sortOrder
    this.threshold = arg.threshold
    this.title = arg.title
    this.description = arg.description
    this.imageUrl = arg.imageUrl
    this.videoUrl = arg.videoUrl
    this.lat = arg.lat
    this.lng = arg.lng
  }

  static fromPG(row: any): Checkpoint {
    return new Checkpoint({
      id: row.id,
      challengeID: row.challenge_id,
      sortOrder: row.sort_order,
      threshold: row.threshold,
      title: row.title,
      description: row.description ?? '',
      imageUrl: row.image_url ?? undefined,
      videoUrl: row.video_url ?? undefined,
      lat: row.lat != null ? Number(row.lat) : undefined,
      lng: row.lng != null ? Number(row.lng) : undefined,
    })
  }

  toPG(): Record<string, unknown> {
    return {
      id: this.id,
      challenge_id: this.challengeID,
      sort_order: this.sortOrder,
      threshold: this.threshold,
      title: this.title,
      description: this.description,
      image_url: this.imageUrl ?? null,
      video_url: this.videoUrl ?? null,
      lat: this.lat ?? null,
      lng: this.lng ?? null,
    }
  }
}
